module.exports = __webpack_public_path__ + "img/HR-Page.dae5cd1b.png";